export const getMarkerZIndex = (index: number, isSelected: boolean, markerCount: number): number =>
  isSelected ? markerCount + 1 : index + 1
